import {CLEAR_NAVIGATE_TO_TIMELINEFRAME, NAVIGATE_TO_TIMELINEFRAME, RECEIVE_GENERIC_PHRASES} from "./actions";

const initialState = {
    timelineEventId: null,
    genericPhrases: null
}

export const timelineFrameReducer = (state = initialState, action) => {
    switch (action.type) {
        case NAVIGATE_TO_TIMELINEFRAME:
            return {
                ...state,
                timelineEventId: action.data
            }
        case CLEAR_NAVIGATE_TO_TIMELINEFRAME:
            return {
                ...state,
                timelineEventId: null
            }
        case RECEIVE_GENERIC_PHRASES:
            return {
                ...state,
                genericPhrases: action.data
            }
        default:
            return state;
    }
}